import classNames from 'classnames';
import PencilSvg from 'components/svg/PencilSvg';
import { ImageSizes } from 'components/ui/Avatar/constants';
import { getDefaultImage } from 'components/ui/Avatar/helpers';
import { BaseSize, DefaultImage } from 'components/ui/Avatar/types';
import { ProfileType } from 'data/interfaces/IRegistration';
import { default as Image, StaticImageData } from 'next/image';
import { FC } from 'react';
import Badge from './Badge';
import styles from './index.module.scss';

interface Props {
  image?: string | StaticImageData;
  role: ProfileType;
  className?: string;
  size: BaseSize;
  active?: boolean;
  typeDefaultImage?: DefaultImage;
  withBadge?: boolean;
}

const Avatar: FC<Props> = ({
  image,
  role,
  size,
  active = false,
  className,
  typeDefaultImage = DefaultImage.Avatar,
  withBadge = false,
}) => {
  return (
    <div className={styles.root}>
      {withBadge && (
        <div className={styles.badgeBox}>
          <Badge icon={<PencilSvg size='small' />} />
        </div>
      )}
      <div
        className={classNames(
          styles.avatar,
          className,
          active && styles[role],
          styles[`avatar__${size}`],
        )}>
        <div className={styles.content}>
          {image ? (
            <Image
              unoptimized
              priority
              src={image}
              alt={'avatar'}
              width={ImageSizes[size]}
              height={ImageSizes[size]}
            />
          ) : (
            getDefaultImage(typeDefaultImage, image, size)
          )}
        </div>
      </div>
    </div>
  );
};

export default Avatar;
